import useMediaQuery from '@restart/hooks/useMediaQuery';
import React from 'react';
import { md } from '../../utils/media-queries';
import { DesktopCards } from './DesktopCards';

export const AdvantagesCards = () => {
  const isAboveMd = useMediaQuery(`(${md})`);

  return <DesktopCards />;
};
